import { PerspectiveUrlConfig, TimeFilter } from "@/models/url";
import type { TracesInMemoryFilters } from "@/store/traces/state";

// Type definition for the Url module VUex state object.
export interface UrlState {
  filters?: any;
  timeFilter: TimeFilter;
  perspectiveConfiguration?: PerspectiveUrlConfig;
  insightPanel?: string;
  regexFilter?: string[];
  sevNumFilter?: string[];
  serviceNameFilter?: string[];
  inMemoryFilters?: TracesInMemoryFilters;
}

/**
 * Create a state object for the url module.
 * @returns A state object initialized for the use in the url module.
 */
export function makeState(): UrlState {
  return {
    filters: undefined,
    timeFilter: { lb: "15m" },
    perspectiveConfiguration: undefined,
    insightPanel: undefined,
    regexFilter: undefined,
    sevNumFilter: undefined,
    serviceNameFilter: undefined,
    inMemoryFilters: undefined,
  };
}
